import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { syncLeadAttributionFromSearch } from "@/lib/leadIdCookie";
import { trackVslPageOpened } from "@/lib/leadEvents";

const VSL_OPEN_SENT_KEY = "fl_vsl_page_opened_sent";

const LeadTracking = () => {
  const { search } = useLocation();
  const sentRef = useRef(false);

  useEffect(() => {
    const { leadId } = syncLeadAttributionFromSearch(search);
    if (!leadId || sentRef.current) {
      return;
    }
    if (sessionStorage.getItem(VSL_OPEN_SENT_KEY) === leadId) {
      return;
    }

    sentRef.current = true;
    trackVslPageOpened(leadId)
      .then(() => {
        sessionStorage.setItem(VSL_OPEN_SENT_KEY, leadId);
      })
      .catch((err) => {
        sentRef.current = false;
        console.warn("[LeadTracking] vsl_page_opened failed", err);
      });
  }, [search]);

  return null;
};

export default LeadTracking;
